import { Box } from "@mui/material";
import { Form } from "generated/graphql";
import { contains } from "helpers/coll";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectCase } from "redux/slices/case";
import { selectForm } from "redux/slices/form.slice";
import CaseHitsBrowser from "../CaseHitsBrowser/CaseHitsBrowser";
import { useLensHitFilterState } from "../LensHitFilterState";
import { useFlags } from "launchdarkly-react-client-sdk";
import { createPortal } from "react-dom";
import { CaseDetailGroup } from "components/CaseDetailGroup";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { PortalContext } from "contexts/PortalContext";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";

const CaseReviewRoute = () => {
  const { caseId, lensId } = useParamNumbers(["caseId", "lensId"]);
  const { searchParams } = useSearchParamsWithUpdate();
  // True means default to alpha; the key should really be 'defaultFindingsSortAlpha'
  const { defaultFindingsSortAlphaLenses } = useFlags();
  const navigate = useNavigate();

  const lensCase = useAppSelector(selectCase);
  const initialSortFindings = contains(defaultFindingsSortAlphaLenses, lensCase.lensId) ? "alpha" : "default";
  const form: Form | undefined = useAppSelector(selectForm);
  const initialFieldId = (() => {
    const fieldParam = searchParams.get("field_id");
    if (fieldParam) return parseInt(fieldParam);
    else return form?.fields[0]?.id || -1;
  })();
  const reviewLensHitFilterState = useLensHitFilterState("grouped", initialSortFindings, initialFieldId, form);

  if (lensId === undefined || caseId === undefined) {
    navigate("../");
    return null;
  }

  const { portalRefElement } = useContext(PortalContext);

  return (
    <>
      {portalRefElement && createPortal(<CaseDetailGroup myCase={lensCase} />, portalRefElement)}
      <Box sx={{ minHeight: 0, display: "flex", height: "100%" }}>
        <CaseHitsBrowser lensId={lensId} lensCase={lensCase} lensHitFilterState={reviewLensHitFilterState} />
      </Box>
    </>
  );
};

export default CaseReviewRoute;
